(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-jr-original]:not([data-jr-ready])').forEach(root => {
      root.dataset.jrReady = 'true';
      if(root.dataset.jrOriginal==='gifts') root.querySelectorAll('[data-jrn-type="ProductDescription"][data-compact]').forEach((description,index)=>{
        const limit=Number(description.dataset.compact);
        if(!limit||description.textContent.trim().split(/\s+/).length<=limit)return;
        const full=document.createElement('div');
        while(description.firstChild)full.append(description.firstChild);
        const compact=full.cloneNode(true);
        let remaining=limit;
        const trim=node=>{
          for(const child of [...node.childNodes]){
            if(remaining===0){child.remove();continue;}
            if(child.nodeType===Node.TEXT_NODE){
              const matches=[...child.textContent.matchAll(/\S+/g)];
              if(matches.length>=remaining){
                const last=matches[remaining-1];
                child.textContent=child.textContent.slice(0,last.index+last[0].length)+'…';
                remaining=0;
              }else remaining-=matches.length;
            }else if(child.nodeType===Node.ELEMENT_NODE)trim(child);
          }
        };
        trim(compact);
        const content=document.createElement('div');
        content.id=`${root.id}-description-${index}`;
        content.append(compact);
        const toggle=document.createElement('a');
        toggle.href='#';toggle.className='jr-description-toggle';
        toggle.setAttribute('role','button');toggle.setAttribute('aria-controls',content.id);
        let expanded=false;
        const update=()=>{content.replaceChildren(expanded?full:compact);toggle.textContent=expanded?'Less':'More';toggle.setAttribute('aria-expanded',String(expanded));};
        const activate=event=>{event.preventDefault();expanded=!expanded;update();};
        toggle.addEventListener('click',activate);
        toggle.addEventListener('keydown',event=>{if(event.key===' '){activate(event);}});
        description.append(content,toggle);update();
      });
      root.querySelectorAll('video img:not([alt])').forEach(img=>{img.alt='';});
      const currency = root.dataset.currency || 'AUD';
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency}).format(cents / 100);
      root.querySelectorAll('form.jrn-product-form').forEach(form => {
        let variants = [];
        try { variants = JSON.parse(form.querySelector('[data-jr-variants]')?.textContent || '[]'); } catch { return; }
        const selectors = [...form.querySelectorAll('[data-jr-option]')];
        const idField = form.querySelector('input[name="id"]');
        const submit = form.querySelector('[data-jrn-type="ProductATC"],[data-jrn-type="ProductATC2"]');
        const originalLabel = submit?.textContent;
        const update = () => {
          const variant = selectors.length ? variants.find(v => selectors.every(s => v.options[Number(s.dataset.jrOption)] === s.value)) : variants.find(v => String(v.id) === idField?.value);
          if(idField) idField.value = variant?.id || '';
          if(submit) { submit.disabled = !variant?.available; submit.textContent = !variant ? 'Unavailable' : !variant.available ? 'Sold out' : originalLabel; }
          if(variant) form.querySelectorAll('[data-product-type="price"]').forEach(el => { el.textContent = money(variant.price); });
          if(variant?.featured_image) {
            const master = form.querySelector('[data-jrn-type="MasterImage"] > img');
            if(master) { master.src = variant.featured_image.src; master.removeAttribute('srcset'); }
            const media = form.querySelector(`[data-media-id="${variant.featured_media?.id || variant.featured_image.id}"]`);
            if(media?.classList.contains('jrn-slide-main-media')) { form.querySelectorAll('.jrn-slide-main-media').forEach(s => {s.hidden=s!==media;}); }
          }
        };
        selectors.forEach(s => s.addEventListener('change', update));
        form.addEventListener('submit', event => { update(); if(!idField?.value || submit?.disabled) event.preventDefault(); });
        update();
      });
      root.querySelectorAll('[data-jrn-type="Tabs"]').forEach((tabs,index) => {
        const buttons = [...tabs.querySelectorAll('[data-jrn-type="TabHeader2"]')];
        const panels = [...tabs.querySelectorAll('[data-jrn-type="TabsContent"]')];
        tabs.querySelector('[data-jrn-type="TabsMenu"]')?.setAttribute('role','tablist');
        const select = i => {
          buttons.forEach((b,n) => {b.dataset.jrnTabActive=String(n===i);b.setAttribute('aria-selected',String(n===i));b.tabIndex=n===i?0:-1;});
          panels.forEach((p,n) => {p.style.display=n===i?'block':'none';p.hidden=n!==i;});
        };
        buttons.forEach((button,i) => {
          button.id=`${root.id}-tab-${index}-${i}`;
          button.setAttribute('role','tab');
          if(panels[i]) {panels[i].id=`${root.id}-panel-${index}-${i}`;panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',button.id);button.setAttribute('aria-controls',panels[i].id);}
          button.addEventListener('click',()=>select(i));
          button.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();let n=event.key==='Home'?0:event.key==='End'?buttons.length-1:(i+(event.key==='ArrowLeft'?-1:1)+buttons.length)%buttons.length;select(n);buttons[n].focus();}});
        });
        select(Math.max(0,buttons.findIndex(b=>b.dataset.jrnTabActive==='true')));
      });
      root.querySelectorAll('[data-quantity-action]').forEach(button=>button.addEventListener('click',()=>{
        const input=button.closest('[data-jrn-type="ProductQuantity"]')?.querySelector('input[name="quantity"]');
        if(!input)return;
        const value=(Number(input.value)||1)+(button.dataset.quantityAction==='increase'?1:-1);
        input.value=String(Math.max(Number(input.min)||1,Math.min(Number(input.max)||Infinity,value)));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      root.querySelectorAll('[data-jrn-type="ProductMedia2"]').forEach(media=>{
        const slides=[...media.querySelectorAll('.jrn-slide-main-media')];
        if(root.dataset.jrOriginal==='gifts'&&media.closest('[data-jrn-type="ProductBox"]')){
          const maximumRatio=Math.max(1,...slides.map(slide=>{
            const img=slide.querySelector(':scope > img');
            if(img)return Number(img.getAttribute('height'))/Number(img.getAttribute('width'))||1;
            const video=slide.querySelector('video');
            return video?parseFloat(video.parentElement.style.getPropertyValue('--r-lg'))/100||1:1;
          }));
          const slider=slides[0]?.parentElement;
          if(slider){
            const resize=()=>{const width=media.getBoundingClientRect().width;if(width>0)slider.style.height=`${width*maximumRatio}px`;};
            new ResizeObserver(resize).observe(media);resize();
          }
        }
        slides.forEach((s,i)=>{s.hidden=i!==0;});
        media.querySelector('.product-media-loading')?.classList.remove('product-media-loading');
        media.querySelectorAll('[data-jrn-type="MediaListItem2"]').forEach(thumb=>{
          thumb.setAttribute('role','button');thumb.tabIndex=0;
          const show=()=>slides.forEach(s=>{s.hidden=s.dataset.mediaId!==thumb.dataset.imgId;});
          thumb.addEventListener('click',show);thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();show();}});
        });
      });
      root.querySelectorAll('[data-jrn-type="ProductImage2"]').forEach(media=>{
        const master=media.querySelector('[data-jrn-type="MasterImage"] > img');
        media.querySelectorAll('[data-jrn-type="ImageItem"] img').forEach(thumb=>thumb.addEventListener('click',()=>{if(master){master.src=thumb.src;master.alt=thumb.alt;}}));
      });
      root.querySelectorAll('[data-href]').forEach(el=>{
        if(el.matches('a,button')||!el.dataset.href)return;
        el.setAttribute('role','link');el.tabIndex=0;
        const navigate=()=>{ const url=new URL(el.dataset.href,location.origin);if(url.origin===location.origin)location.assign(url.href); };
        el.addEventListener('click',navigate);el.addEventListener('keydown',e=>{if(e.key==='Enter')navigate();});
      });
      root.querySelectorAll('.jr-carousel-nav').forEach(nav=>{
        const list=nav.previousElementSibling;
        if(!list?.classList.contains('js-product-list'))return;
        const renderDots=()=>{
          const item=list.querySelector('.jrl-collection-item');
          if(!item)return;
          const visible=Math.max(1,Math.round(list.clientWidth/item.getBoundingClientRect().width));
          const count=Math.ceil(list.children.length/visible);
          nav.replaceChildren();
          for(let i=0;i<count;i++){
            const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`Show product group ${i+1}`);
            button.addEventListener('click',()=>list.scrollTo({left:(list.clientWidth+30)*i,behavior:'smooth'}));nav.append(button);
          }
          updateDots();
        };
        const updateDots=()=>{const active=Math.round(list.scrollLeft/(list.clientWidth+30));[...nav.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===active)));};
        list.addEventListener('scroll',updateDots,{passive:true});new ResizeObserver(renderDots).observe(list);renderDots();
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
